export const wallWidth = 15000 / 1000;
export const wallHeight = 10000 / 1000;
// export const wallSpaceMaxWidth = 5000 / 1000;
export const wallSpaceMaxHeight = 3500 / 1000;
export const wallColor = "#EEEEEE";
export const imageOverlap = 3.5 / 1000;
export const frameDepth = 16.5 / 1000;
export const rimDepth = 3.5 / 1000;
export const angle = Math.PI / 6;
export const offset = 1.1;
export const cameraFov = 45;
export const initialCameraFov = 45;
export const cameraMargin = 0.05;
export const additionalCameraYMargin = 0.07;
export const dimensionTextSizeBase = 0.02;
export const dimensionTextOffsetBase = 0.02;
export const dimensionLineOffsetBase = 0.024;
export const diagonalLineLengthBase = 0.01;
export const dimensionTextReferenceCameraZ = 2.7;
export const editMenuOffsetYFactor = 0.4;
export const editMenuGapXFactor = 0.2;
export const animationTolerance = 10 ** -6;
export const maxAnimationDelta = 0.1
